module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-12-ddfba8cd1f4189222b28732462e99894.jpg";